import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export const setupSerwistUpdates = ({
  serwist,
  routerEvents,
  windowRef
}) => {
  let waiting = false;
  let activationRequested = false;
  const onWaiting = () => {
    waiting = true;
  };
  const onControlling = () => {
    const reload = activationRequested;
    waiting = false;
    activationRequested = false;
    if (reload) windowRef.location.reload();
  };
  const onRouteComplete = (_url, {
    shallow
  } = {}) => {
    if (!waiting || shallow) return;
    activationRequested = true;
    serwist.messageSkipWaiting();
  };
  serwist.addEventListener("waiting", onWaiting);
  serwist.addEventListener("controlling", onControlling);
  routerEvents.on("routeChangeComplete", onRouteComplete);
  return () => {
    serwist.removeEventListener("waiting", onWaiting);
    serwist.removeEventListener("controlling", onControlling);
    routerEvents.off("routeChangeComplete", onRouteComplete);
  };
};

/** Register Serwist and apply a waiting worker after the next full route. */
export default function useSerwistUpdate(t0) {
  const $ = _c(5);
  const {
    router,
    SerwistClass,
    scriptUrl
  } = t0;
  let t1;
  let t2;
  if ($[0] !== SerwistClass || $[1] !== router.events || $[2] !== scriptUrl) {
    t1 = () => {
      if (process.env.NODE_ENV !== "production" || typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
        return;
      }
      if (!(window.serwist instanceof SerwistClass)) {
        window.serwist = new SerwistClass(scriptUrl, {
          scope: "/",
          updateViaCache: "none"
        });
      }
      const serwist = window.serwist;
      const cleanup = setupSerwistUpdates({
        serwist,
        routerEvents: router.events,
        windowRef: window
      });
      serwist.register().catch(_temp);
      return () => {
        cleanup();
      };
    };
    t2 = [SerwistClass, scriptUrl, router.events];
    $[0] = SerwistClass;
    $[1] = router.events;
    $[2] = scriptUrl;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
}
function _temp(error) {
  return console.error("Service worker registration failed:", error);
}